const SCREENS = [
    { id: "home", label: "Home" },
    { id: "apps", label: "Apps" },
    { id: "info", label: "Information" },
    { id: "radio", label: "Radio" },
    { id: "hotel", label: "Hotel" },
    { id: "custom", label: "Custom" },
    { id: "offers", label: "Offers" },
    { id: "vod", label: "Films & series" },
    { id: "guide", label: "TV guide" },
    { id: "cast", label: "Screen Share" },
];
const CUSTOM_KNOBS = [
    {
        id: "showCustom",
        label: "Custom",
        help: "A screen of your own, named whatever you call it. Switch it on to get it in the menu, then fill it in under its own tab.",
        type: "toggle",
        default: false,
        group: "Main menu",
        controls: { kind: "screen", id: "custom" },
        titleKnobId: "customTitle",
    },
    {
        id: "customTitle",
        label: "Title",
        help: "What this screen is called - in the menu here and on the TV.",
        type: "text",
        default: "Custom",
        placeholder: "Custom",
        maxLength: 32,
        group: "Main menu",
    },
];
const OFFERS_KNOBS = [
    {
        id: "showOffers",
        label: "Offers",
        help: "The things guests can order or book from the television - room service, a spa hour, late checkout. Switch it on to get it in the menu, then author the offers under Offers. The tile only appears once there is something live to show.",
        type: "toggle",
        default: false,
        group: "Main menu",
        controls: { kind: "screen", id: "offers" },
        titleKnobId: "offersTitle",
    },
    {
        id: "offersTitle",
        label: "Title",
        help: "What this screen is called - in the menu here and on the TV.",
        type: "text",
        default: "Offers",
        placeholder: "Offers",
        maxLength: 32,
        group: "Main menu",
    },
];
const PLAYER_KNOBS = [
    {
        id: "showVod",
        label: "Films & series",
        help: "Foyer's own film and series catalogue, played on the television itself instead of handing the screen to another app. Switch it on to get it in the menu. The tile only appears once the room's packages actually carry something to watch.",
        type: "toggle",
        default: false,
        group: "Main menu",
        controls: { kind: "screen", id: "vod" },
        titleKnobId: "vodTitle",
    },
    {
        id: "vodTitle",
        label: "Title",
        help: "What this screen is called - in the menu here and on the TV.",
        type: "text",
        default: "Films & series",
        placeholder: "Films & series",
        maxLength: 32,
        group: "Main menu",
    },
    {
        id: "showGuide",
        label: "TV guide",
        help: "The live channel line-up and what is on now, drawn by Foyer itself. Switch it on to get it in the menu. The tile only appears once the room actually has channels.",
        type: "toggle",
        default: false,
        group: "Main menu",
        controls: { kind: "screen", id: "guide" },
        titleKnobId: "guideTitle",
    },
    {
        id: "guideTitle",
        label: "Title",
        help: "What this screen is called - in the menu here and on the TV.",
        type: "text",
        default: "TV guide",
        placeholder: "TV guide",
        maxLength: 32,
        group: "Main menu",
    },
];
const HOME_KNOBS = [
    {
        id: "showCast",
        label: "Screen Share",
        help: "Shows the Screen Share tile. Pressing it opens the television's own screen-sharing receiver so the guest sees the real device name and code. Where the device has nothing to open, on-screen instructions show instead.",
        type: "toggle",
        default: true,
        group: "Sections",
        controls: { kind: "screen", id: "cast" },
    },
    {
        id: "showApps",
        label: "Apps",
        type: "toggle",
        default: true,
        group: "Sections",
        controls: { kind: "screen", id: "apps" },
    },
    {
        id: "showInfo",
        label: "Information",
        type: "toggle",
        default: true,
        group: "Sections",
        controls: { kind: "screen", id: "info" },
    },
    {
        id: "showRadio",
        label: "Radio",
        type: "toggle",
        default: true,
        group: "Sections",
        controls: { kind: "screen", id: "radio" },
    },
    {
        id: "showPromotions",
        label: "Promotion",
        help: "Show the promotion banner / QR on the home screen. Fill it under Promotions.",
        type: "toggle",
        default: false,
        group: "Home screen",
    },
    {
        id: "homeOrder",
        label: "Home tile order",
        type: "order",
        group: "Layout",
        items: [
            { id: "apps", label: "Apps" },
            { id: "info", label: "Information" },
            { id: "radio", label: "Radio" },
            { id: "custom", label: "Custom" },
            { id: "offers", label: "Offers" },
            { id: "vod", label: "Films & series" },
            { id: "guide", label: "TV guide" },
        ],
        default: ["apps", "info", "radio"],
    },
    ...CUSTOM_KNOBS,
    ...OFFERS_KNOBS,
    ...PLAYER_KNOBS,
];
const HOTEL_PROMO_SLOT = {
    id: "homePromo",
    label: "Promotion",
    help: "A banner, a QR or one of your offers on the home screen - promote a spa weekend, link your menu, share Wi-Fi, or put a bookable offer where guests already look. The template decides where it sits and how it looks; you just supply the content.",
    accepts: ["announcement", "qr", "offer"],
};
export const atelierManifest = {
    key: "atelier",
    segment: "hotel",
    name: "Atelier",
    description: "Cream paper, deep navy, warm gold. Serif headlines, hairline rules.",
    screens: SCREENS,
    defaultTokens: {
        palette: {
            bg: "#f5efe4",
            ink: "#1A1D3D",
            inkDim: "#6b6354",
            rule: "rgba(26,29,61,0.16)",
            accent: "#b8995c",
        },
        fonts: {
            serif: '"Cormorant Garamond", "EB Garamond", Georgia, serif',
            sans: '"Inter Tight", "Inter", system-ui, sans-serif',
            mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
        },
        extras: {
            paperDk: "#ebe3d3",
            ink2: "#3a3856",
            ruleSf: "rgba(26,29,61,0.08)",
            goldDk: "#94783f",
        },
    },
    tokenSchema: {
        palette: [
            { key: "bg", label: "Paper" },
            { key: "ink", label: "Ink" },
            { key: "inkDim", label: "Taupe" },
            { key: "rule", label: "Hairline" },
            { key: "accent", label: "Gold" },
        ],
        extras: [
            { key: "paperDk", label: "Paper (dark)", kind: "color" },
            { key: "ink2", label: "Ink (secondary)", kind: "color" },
            { key: "ruleSf", label: "Hairline (soft)", kind: "color" },
            { key: "goldDk", label: "Gold (dark)", kind: "color" },
        ],
    },
    slots: [HOTEL_PROMO_SLOT],
    knobs: HOME_KNOBS,
};
export const mosaicManifest = {
    key: "mosaic",
    segment: "hotel",
    name: "Mosaic",
    description: "Saturated color-blocked tiles, brick-red italic emphasis, asymmetric bento.",
    screens: SCREENS,
    defaultTokens: {
        palette: {
            bg: "#faf8f3",
            ink: "#1A1D3D",
            inkDim: "#7b7565",
            rule: "rgba(26,29,61,0.10)",
            accent: "#d3624a",
        },
        fonts: {
            serif: '"Instrument Serif", "Playfair Display", Georgia, serif',
            sans: '"DM Sans", "Onest", "Inter Tight", system-ui, sans-serif',
            mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
        },
        extras: {
            paper2: "#f1ede2",
            navy: "#1A1D3D",
            cream: "#f1e6c8",
            butter: "#ffd86b",
            sage: "#a3c293",
            blush: "#f7c5cc",
            plum: "#523171",
            ocean: "#3b82c4",
        },
    },
    tokenSchema: {
        palette: [
            { key: "bg", label: "Paper" },
            { key: "ink", label: "Ink" },
            { key: "inkDim", label: "Taupe" },
            { key: "rule", label: "Hairline" },
            { key: "accent", label: "Brick (accent)" },
        ],
        extras: [
            { key: "paper2", label: "Paper 2", kind: "color" },
            { key: "navy", label: "Navy", kind: "color" },
            { key: "cream", label: "Cream", kind: "color" },
            { key: "butter", label: "Butter", kind: "color" },
            { key: "sage", label: "Sage", kind: "color" },
            { key: "blush", label: "Blush", kind: "color" },
            { key: "plum", label: "Plum", kind: "color" },
            { key: "ocean", label: "Ocean", kind: "color" },
        ],
    },
    slots: [HOTEL_PROMO_SLOT],
    knobs: HOME_KNOBS,
};
export const spectrumManifest = {
    key: "spectrum",
    segment: "hotel",
    name: "Spectrum",
    description: "Glass cards on a periwinkle nebula, gradient text, isometric 3D floor stack.",
    screens: SCREENS,
    defaultTokens: {
        palette: {
            bg: "#0a0d18",
            ink: "#f4f3ff",
            inkDim: "rgba(244,243,255,0.62)",
            rule: "rgba(255,255,255,0.10)",
            accent: "#7c6cff",
            accent2: "#21d4fd",
        },
        fonts: {
            sans: '"Onest", "Inter Tight", system-ui, sans-serif',
            mono: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',
        },
        extras: {
            inkSf: "rgba(244,243,255,0.42)",
            ruleSf: "rgba(255,255,255,0.06)",
            glass: "rgba(255,255,255,0.06)",
            glassH: "rgba(255,255,255,0.10)",
            glow: "rgba(124,108,255,0.55)",
        },
    },
    tokenSchema: {
        palette: [
            { key: "bg", label: "Background" },
            { key: "ink", label: "Ink" },
            { key: "inkDim", label: "Ink (dim)" },
            { key: "rule", label: "Hairline" },
            { key: "accent", label: "Accent (violet)" },
            { key: "accent2", label: "Accent 2 (cyan)" },
        ],
        extras: [
            { key: "inkSf", label: "Ink (soft)", kind: "color" },
            { key: "ruleSf", label: "Hairline (soft)", kind: "color" },
            { key: "glass", label: "Glass", kind: "color" },
            { key: "glassH", label: "Glass (hover)", kind: "color" },
            { key: "glow", label: "Glow", kind: "color" },
        ],
    },
    slots: [HOTEL_PROMO_SLOT],
    knobs: HOME_KNOBS,
};
const CARE_HOME_KNOBS = [
    {
        id: "showCall",
        label: "Ring personal",
        help: "Visar rutan 'Ring personal' på startsidan så den boende kan kalla på personal från TV:n. Kräver att boendet har en bemanningsrutin för larmen - slå bara på den när någon faktiskt tar emot dem.",
        type: "toggle",
        default: false,
        group: "Main menu",
        controls: { kind: "screen", id: "call" },
    },
    {
        id: "showApps",
        label: "Nöje",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "apps" },
    },
    {
        id: "showRadio",
        label: "Radio",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "radio" },
    },
    {
        id: "showInfo",
        label: "Info",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "info" },
    },
    {
        id: "showRelatives",
        label: "Anhöriga",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "relatives" },
    },
    {
        id: "showPhotos",
        label: "Foton från familjen",
        help: "Familjemedlemmar skickar foton via e-post till rummets adress; godkända foton visas direkt på TV.",
        type: "toggle",
        default: false,
        group: "Main menu",
        controls: { kind: "screen", id: "photos" },
    },
    {
        id: "homeOrder",
        label: "Menu order",
        type: "order",
        group: "Main menu",
        items: [
            { id: "apps", label: "Nöje" },
            { id: "radio", label: "Radio" },
            { id: "info", label: "Info" },
            { id: "relatives", label: "Anhöriga" },
            { id: "videocall", label: "Videosamtal" },
            { id: "photos", label: "Foton" },
            { id: "menu", label: "Matsedel" },
            { id: "wifi", label: "Wi-Fi" },
            { id: "welcome", label: "Välkommen" },
            { id: "instagram", label: "Instagram" },
            { id: "weather", label: "Väder" },
            { id: "custom", label: "Custom" },
        ],
        default: ["apps", "radio", "info", "relatives", "videocall", "photos"],
    },
    {
        id: "infoOrder",
        label: "Information order",
        type: "order",
        group: "Information",
        items: [
            { id: "menu", label: "Matsedel" },
            { id: "wifi", label: "Wi-Fi" },
            { id: "welcome", label: "Välkommen" },
            { id: "instagram", label: "Instagram" },
            { id: "weather", label: "Väder" },
            { id: "vilmer", label: "VilMer" },
            { id: "relatives", label: "Anhöriga" },
            { id: "photos", label: "Foton" },
        ],
        default: ["menu", "vilmer", "wifi", "welcome", "instagram", "weather"],
    },
    {
        id: "showMenu",
        label: "Matsedel",
        help: "Veckans matsedel - måndag till söndag med veckonummer. Ligger under Info, inte på startsidan. Fyll i den för hand under Mall → Matsedel, eller koppla kökets RSS-flöde så uppdateras den av sig själv.",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "menu" },
    },
    {
        id: "showWifi",
        label: "Wi-Fi",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "wifi" },
    },
    {
        id: "showWelcome",
        label: "Välkommen",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "welcome" },
    },
    {
        id: "showInstagram",
        label: "Instagram",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "instagram" },
    },
    {
        id: "showWeather",
        label: "Väder",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "weather" },
    },
    {
        id: "showVilmer",
        label: "VilMer",
        help: "Aktiviteter från VilMer - dagens och veckans program, med beskrivning av varje aktivitet. Ligger under Info. Ange VilMers API-adress under Mall → VilMer, och klistra in varje rums integrationstoken under Rum.",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "vilmer" },
    },
    ...CUSTOM_KNOBS,
];
export const careManifest = {
    key: "care",
    segment: "care",
    name: "Hemvist",
    description: "Calm care launcher. Warm paper, deep green, Figtree. Oversized type and focus rings for elderly residents on a remote.",
    screens: [
        { id: "home", label: "Launcher" },
        { id: "apps", label: "Nöje" },
        { id: "radio", label: "Radio" },
        { id: "info", label: "Info" },
        { id: "menu", label: "Matsedel" },
        { id: "vilmer", label: "VilMer" },
        { id: "wifi", label: "Wi-Fi" },
        { id: "welcome", label: "Välkommen" },
        { id: "relatives", label: "Anhöriga" },
        { id: "instagram", label: "Instagram" },
        { id: "weather", label: "Väder" },
        { id: "tv", label: "TV" },
        { id: "photos", label: "Foton från familjen" },
        { id: "call", label: "Ring personal" },
        { id: "videocall", label: "Videosamtal" },
        { id: "custom", label: "Custom" },
    ],
    defaultTokens: {
        palette: {
            bg: "#EFEDE4",
            ink: "#171915",
            inkDim: "#5F665C",
            rule: "#E4E1D4",
            accent: "#3D6B49",
            accent2: "#1F3D2A",
        },
        fonts: {
            sans: '"Figtree", system-ui, -apple-system, sans-serif',
            mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
        },
        extras: {
            paper2: "#E7E4D9",
            surface: "#FFFFFF",
            surface2: "#FAF8F2",
            hair: "#D8D4C6",
            inkMuted: "#8E948A",
            gSoft: "#A8C3A4",
            gTint: "#E3ECD8",
            gGlow: "#C7DDB8",
        },
    },
    tokenSchema: {
        palette: [
            { key: "bg", label: "Paper" },
            { key: "ink", label: "Ink" },
            { key: "inkDim", label: "Ink (soft)" },
            { key: "rule", label: "Hairline" },
            { key: "accent", label: "Green (core)" },
            { key: "accent2", label: "Green (deep)" },
        ],
        extras: [
            { key: "paper2", label: "Paper (dark)", kind: "color" },
            { key: "surface", label: "Surface", kind: "color" },
            { key: "surface2", label: "Surface 2", kind: "color" },
            { key: "hair", label: "Hairline (strong)", kind: "color" },
            { key: "inkMuted", label: "Ink (muted)", kind: "color" },
            { key: "gSoft", label: "Green (soft)", kind: "color" },
            { key: "gTint", label: "Green (tint)", kind: "color" },
            { key: "gGlow", label: "Green (glow)", kind: "color" },
        ],
    },
    knobs: CARE_HOME_KNOBS,
};
const LAUNCHER_SCREENS = [
    { id: "home", label: "Home" },
    { id: "cast", label: "Screen Share" },
    { id: "apps", label: "Apps" },
    { id: "info", label: "Information" },
    { id: "radio", label: "Radio" },
    { id: "wifi", label: "Wi-Fi" },
    { id: "welcome", label: "Welcome" },
    { id: "instagram", label: "Instagram" },
    { id: "weather", label: "Weather" },
    { id: "custom", label: "Custom" },
    { id: "offers", label: "Offers" },
    { id: "vod", label: "Films & series" },
    { id: "guide", label: "TV guide" },
];
const LAUNCHER_KNOBS = [
    {
        id: "showCast",
        label: "Screen Share",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "cast" },
    },
    {
        id: "showApps",
        label: "Apps",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "apps" },
    },
    {
        id: "showInfo",
        label: "Information",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "info" },
    },
    {
        id: "showRadio",
        label: "Radio",
        type: "toggle",
        default: true,
        group: "Main menu",
        controls: { kind: "screen", id: "radio" },
    },
    {
        id: "functionOrder",
        label: "Menu order",
        type: "order",
        group: "Main menu",
        items: [
            { id: "cast", label: "Screen Share" },
            { id: "apps", label: "Apps" },
            { id: "info", label: "Information" },
            { id: "radio", label: "Radio" },
            { id: "custom", label: "Custom" },
            { id: "offers", label: "Offers" },
            { id: "vod", label: "Films & series" },
            { id: "guide", label: "TV guide" },
        ],
        default: ["cast", "apps", "info", "radio"],
    },
    {
        id: "showPromotions",
        label: "Promotion",
        help: "Show the promotion banner / QR on the home screen. Fill it under Promotions.",
        type: "toggle",
        default: false,
        group: "Home screen",
    },
    {
        id: "showWifi",
        label: "Wi-Fi",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "wifi" },
    },
    {
        id: "showWelcome",
        label: "Welcome",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "welcome" },
    },
    {
        id: "showInstagram",
        label: "Instagram",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "instagram" },
    },
    {
        id: "showWeather",
        label: "Weather",
        type: "toggle",
        default: false,
        group: "Information",
        controls: { kind: "screen", id: "weather" },
    },
    ...CUSTOM_KNOBS,
    ...OFFERS_KNOBS,
    ...PLAYER_KNOBS,
];
const LAUNCHER_IMAGE_SLOTS = [
    { id: "hero", label: "Property photo", aspect: "16:9" },
];
const LAUNCHER_PALETTE_SCHEMA = [
    { key: "bg", label: "Background" },
    { key: "ink", label: "Ink" },
    { key: "inkDim", label: "Ink (muted)" },
    { key: "rule", label: "Hairline" },
    { key: "accent", label: "Accent" },
];
const LAUNCHER_EXTRAS_SCHEMA = [
    { key: "surface", label: "Sub-page surface", kind: "color" },
    { key: "card", label: "Card", kind: "color" },
    { key: "chip", label: "Chip", kind: "color" },
    { key: "onAccent", label: "On-accent", kind: "color" },
    { key: "phTone", label: "Placeholder", kind: "color" },
    { key: "phInk", label: "Placeholder ink", kind: "color" },
];
const LAUNCHER_TOKEN_SCHEMA = {
    palette: LAUNCHER_PALETTE_SCHEMA,
    extras: LAUNCHER_EXTRAS_SCHEMA,
};
export const aureliaManifest = {
    key: "aurelia",
    segment: "hotel",
    name: "Aurelia",
    description: "Grand timeless luxury. Full-bleed photo, centered brass dock. Dark espresso + brass, Cormorant Garamond.",
    screens: LAUNCHER_SCREENS,
    defaultTokens: {
        palette: {
            bg: "#15100c",
            ink: "#efe6d6",
            inkDim: "rgba(239,230,214,0.62)",
            rule: "rgba(198,166,103,0.22)",
            accent: "#c6a667",
        },
        fonts: {
            serif: '"Cormorant Garamond", Georgia, serif',
            sans: '"Jost", system-ui, sans-serif',
        },
        extras: {
            surface: "#1a140e",
            card: "rgba(198,166,103,0.07)",
            chip: "rgba(198,166,103,0.14)",
            onAccent: "#1a140e",
            phTone: "#2a211a",
            phInk: "rgba(198,166,103,0.22)",
        },
    },
    tokenSchema: LAUNCHER_TOKEN_SCHEMA,
    imageSlots: LAUNCHER_IMAGE_SLOTS,
    slots: [HOTEL_PROMO_SLOT],
    knobs: LAUNCHER_KNOBS,
};
export const mareaManifest = {
    key: "marea",
    segment: "hotel",
    name: "Marea",
    description: "Coastal resort. Split sand brand panel + ocean photo. Sea-glass accent, Newsreader / Work Sans.",
    screens: LAUNCHER_SCREENS,
    defaultTokens: {
        palette: {
            bg: "#f5f0e8",
            ink: "#2b3a35",
            inkDim: "rgba(43,58,53,0.55)",
            rule: "rgba(43,58,53,0.12)",
            accent: "#5f938a",
        },
        fonts: {
            serif: '"Newsreader", Georgia, serif',
            sans: '"Work Sans", system-ui, sans-serif',
        },
        extras: {
            surface: "#efe9df",
            card: "#ffffff",
            chip: "#e7ded0",
            onAccent: "#ffffff",
            phTone: "#bcd0cc",
            phInk: "rgba(43,58,53,0.26)",
        },
    },
    tokenSchema: LAUNCHER_TOKEN_SCHEMA,
    imageSlots: LAUNCHER_IMAGE_SLOTS,
    slots: [HOTEL_PROMO_SLOT],
    knobs: LAUNCHER_KNOBS,
};
export const nordManifest = {
    key: "nord",
    segment: "hotel",
    name: "Nord",
    description: "Urban design hotel. Minimal full-bleed, giant clock + thin nav strip. Monochrome + terracotta, Space Grotesk / Space Mono.",
    screens: LAUNCHER_SCREENS,
    defaultTokens: {
        palette: {
            bg: "#16140f",
            ink: "#f4f2ec",
            inkDim: "rgba(244,242,236,0.6)",
            rule: "rgba(244,242,236,0.14)",
            accent: "#e0734f",
        },
        fonts: {
            serif: '"Space Grotesk", system-ui, sans-serif',
            sans: '"Space Grotesk", system-ui, sans-serif',
            mono: '"Space Mono", ui-monospace, monospace',
        },
        extras: {
            surface: "#16140f",
            card: "rgba(244,242,236,0.05)",
            chip: "rgba(244,242,236,0.10)",
            onAccent: "#16140f",
            phTone: "#26231d",
            phInk: "rgba(244,242,236,0.16)",
        },
    },
    tokenSchema: LAUNCHER_TOKEN_SCHEMA,
    imageSlots: LAUNCHER_IMAGE_SLOTS,
    slots: [HOTEL_PROMO_SLOT],
    knobs: LAUNCHER_KNOBS,
};
export const terraManifest = {
    key: "terra",
    segment: "hotel",
    name: "Terra",
    description: "Warm boutique. Slim left icon sidebar + photo. Terracotta + cream, Spectral / DM Sans.",
    screens: LAUNCHER_SCREENS,
    defaultTokens: {
        palette: {
            bg: "#f1e8db",
            ink: "#3a2d24",
            inkDim: "rgba(58,45,36,0.55)",
            rule: "rgba(58,45,36,0.12)",
            accent: "#b3552f",
        },
        fonts: {
            serif: '"Spectral", Georgia, serif',
            sans: '"DM Sans", system-ui, sans-serif',
        },
        extras: {
            surface: "#f1e8db",
            card: "#ffffff",
            chip: "#e7dccb",
            onAccent: "#f1e8db",
            phTone: "#c9a98c",
            phInk: "rgba(58,45,36,0.24)",
            panel: "#e7dccb",
        },
    },
    tokenSchema: {
        palette: LAUNCHER_PALETTE_SCHEMA,
        extras: [
            ...LAUNCHER_EXTRAS_SCHEMA,
            { key: "panel", label: "Sidebar", kind: "color" },
        ],
    },
    imageSlots: LAUNCHER_IMAGE_SLOTS,
    slots: [HOTEL_PROMO_SLOT],
    knobs: LAUNCHER_KNOBS,
};
export const tannManifest = {
    key: "tann",
    segment: "hotel",
    name: "Tann",
    description: "Alpine retreat. Top nav bar + photo + 'Now on TV' lower-third. Forest green + amber, Marcellus / Manrope.",
    screens: LAUNCHER_SCREENS,
    defaultTokens: {
        palette: {
            bg: "#19241d",
            ink: "#ece3d3",
            inkDim: "rgba(236,227,211,0.6)",
            rule: "rgba(236,227,211,0.16)",
            accent: "#d4a35a",
        },
        fonts: {
            serif: '"Marcellus", Georgia, serif',
            sans: '"Manrope", system-ui, sans-serif',
        },
        extras: {
            surface: "#19241d",
            card: "rgba(236,227,211,0.06)",
            chip: "rgba(236,227,211,0.12)",
            onAccent: "#19241d",
            phTone: "#2c3a30",
            phInk: "rgba(212,163,90,0.18)",
        },
    },
    tokenSchema: LAUNCHER_TOKEN_SCHEMA,
    imageSlots: LAUNCHER_IMAGE_SLOTS,
    slots: [HOTEL_PROMO_SLOT],
    knobs: LAUNCHER_KNOBS,
};
export function defaultSchemeForSegment(segment) {
    return segment === "care" ? "care" : "atelier";
}
export const SCHEME_MANIFESTS = {
    atelier: atelierManifest,
    mosaic: mosaicManifest,
    spectrum: spectrumManifest,
    care: careManifest,
    aurelia: aureliaManifest,
    marea: mareaManifest,
    nord: nordManifest,
    terra: terraManifest,
    tann: tannManifest,
};
